/** Train subpackage messages — English */
export default {
  train: {
    nav: {
      home: 'Trains',
      list: 'Select train',
      detail: 'Train details',
      orderFill: 'Checkout',
      orderDetail: 'Order details',
      change: 'Change ticket',
      changeOrderDetail: 'Change order details',
      refundApply: 'Request refund',
      refundProgress: 'Refund status',
      stationFrom: 'From',
      stationTo: 'To',
      passengerAdd: 'Add passenger',
      passengerEdit: 'Edit passenger',
      routeTitle: '{from} → {to}',
    },
    common: {
      copy: 'Copy',
      cancel: 'Cancel',
      confirm: 'Confirm',
      reset: 'Reset',
      clear: 'Clear',
      book: 'Book',
      payNow: 'Pay now',
      submitOrder: 'Submit order',
      detail: 'Details',
      fromStation: 'From',
      toStation: 'To',
      departure: 'Departure',
      arrival: 'Arrival',
      departureDate: 'Departure date',
      searchTickets: 'Search trains',
      highSpeedOnly: 'High-speed rail',
      customerService: 'Contact support',
      actualPaid: 'Paid',
      subtotal: 'Subtotal',
      total: 'Total',
      serviceFee: 'Service fee',
      copySuccess: 'Copied',
      unionOrderBadge: 'Bundle',
      loading: 'Loading',
      orderNo: 'Order No.: {id}',
      ticketNo: 'Ticket No.: {id}',
      ticketPrice: 'Fare',
      totalAmount: 'Order total',
      grandTotal: 'Total',
      transfer: 'Stops',
      checkGate: 'Gate:',
      expandAllPassengers: 'Show all passengers ({count})',
      acceptStanding: 'Accept standing',
      reorder: 'Book again',
      buyReturn: 'Book return',
      changeTicket: 'Change',
      refundTicket: 'Refund',
      cancelOrder: 'Cancel order',
      refundProgressLink: 'View refund status >',
      hasRefund: 'Refund issued',
      remaining: '{time} left',
      selectAll: 'Select all',
      deselectAll: 'Deselect all',
      addEditPassenger: 'Add / edit passengers',
      onlineSeatSelect: 'Seat selection',
      refundChangeRules: 'Change & refund policy',
      warmReminder: 'Reminder',
      serviceAgreement: 'Terms of service',
      agreeAllAgreements: 'I have read and agree to all terms above',
      pleaseCheckAgreement: 'Please accept the terms before submitting',
      bookNow: 'Book now',
      submitChange: 'Submit change ({count})',
      coupon: 'Coupon',
      noCouponAvailable: 'No coupons available',
      couponSelected: 'Coupon applied -￥{amount}',
      noThreshold: 'No minimum',
      couponDiscount: 'Spend {min}, save {price}',
      couponInstantOff: 'Save ￥{price}',
      couponPercent: 'Spend {min}, {price}% off',
      originalTicket: 'Original ticket',
      changeTicketTag: 'Changed ticket {index}',
      changeOrderTag: 'Change order {index}',
      changedOrRefunded: 'Changed / refunded',
      verifying: 'Verifying…',
      lowest: 'From',
      dayDiff: '+{days}',
      dash: '—',
      unknownSeat: 'Unknown seat',
      unknownStatus: 'Unknown status',
      invoice: 'Invoice',
      noTrainInvoice: 'No train invoices',
      swipeHint: 'Swipe for more',
      shareRouteTitle: '{from}→{to} trains',
      shareRouteTitleSpace: '{from}→{to} trains',
      shareDesc: 'Interest-free installments · 0 fees · Trusted by 40+ banks',
      shareBooking: 'Booking {from}-{to} train tickets on Interest-free travel',
      searchQuery: 'Train search',
      domesticBooking: 'China rail tickets',
      hotelBundleTitle: 'Add a hotel — up to 12 interest-free installments',
      hotelBundleDesc: 'Bundle train + hotel for extra savings',
      goSelectHotel: 'Choose hotel',
      gotIt: 'Got it',
      tip: 'Notice',
      confirmDelete: 'Confirm delete',
      deletePassengerMsg: 'Delete passenger "{name}"?',
      smsVerify: 'Please complete SMS verification',
      continueOrder: 'Continue booking',
      continueChange: 'Continue change',
      nonRefundableConfirm: 'This ticket is non-refundable. Continue with {action}?',
      loadingOrder: 'Loading order…',
      selectedCount: '{count} selected',
      changeBadge: 'Changed',
      notChangeable: 'Cannot change',
      selectDate: 'Select date',
      tipTitle: 'Tips',
      customerServicePhone: 'Support: 4007659936',
      peopleUnit: '{count} passenger(s)',
      secondClass: 'Second class',
      ticketType: {
        adult: 'Adult',
        child: 'Child',
        student: 'Student',
        disabledMilitary: 'Disabled military',
      },
      cardType: {
        idCard: 'ID card',
        passport: 'Passport',
        hkMacao: 'HK/Macau pass',
        twCompatriot: 'Taiwan compatriot pass',
      },
    },
    date: {
      today: 'Today',
      tomorrow: 'Tomorrow',
      dayAfter: 'Day after tomorrow',
      weekdaySun: 'Sun',
      weekdayMon: 'Mon',
      weekdayTue: 'Tue',
      weekdayWed: 'Wed',
      weekdayThu: 'Thu',
      weekdayFri: 'Fri',
      weekdaySat: 'Sat',
      monthDay: '{month}/{day}',
      monthDayTime: '{month}/{day} {time}',
      departTitle: '{date} ({day}) departure',
      departSuffix: 'departure',
      pleaseSelect: 'Select a date',
      nightBadge: 'Overnight',
    },
    seat: {
      soldOut: 'Sold out',
      available: 'Available',
      tight: 'Few left',
      none: 'None',
      hasTicket: 'Available',
      noTicket: 'Sold out',
      lowestPrice: 'From',
      acceptStanding: 'Accept standing',
    },
    stop: {
      transfer: 'Stops',
      timetable: 'Timetable',
      title: 'Timetable',
      titleWithNo: '{trainNo} timetable',
      col: {
        station: 'Station',
        arrive: 'Arrive',
        depart: 'Depart',
        stay: 'Stop',
      },
      disclaimer: 'Times are subject to actual operation; please follow station announcements',
      loading: 'Loading timetable…',
      loadingTimetable: 'Loading stops…',
    },
    filter: {
      title: 'Filters',
      advanced: 'Filters',
      onlyAvailable: 'Available only',
      highSpeed: 'High-speed',
      fuxing: 'Fuxing',
      quietCar: 'Quiet car',
      quietCarOnly: 'Quiet car only',
      seatType: 'Seat class',
      trainType: 'Train type',
      departTime: 'Departure time',
      arriveTime: 'Arrival time',
      fromStation: 'Departure station',
      toStation: 'Arrival station',
      recommend: 'Recommended',
      departAt: 'Depart {time}',
      arriveAt: 'Arrive {time}',
      departFrom: 'From {station}',
      arriveAtStation: 'To {station}',
      loadingTrains: 'Searching trains…',
      emptyTrains: 'No trains found',
      emptyTrainsTip: 'Try adjusting your search',
      trainTypeG: 'G High-speed EMU',
      trainTypeD: 'D EMU',
      trainTypeS: 'S Suburban',
      trainTypeZ: 'Z Direct express',
      trainTypeT: 'T Express',
      trainTypeK: 'K Fast',
      trainTypeC: 'C Intercity',
      trainTypeN: 'N Regional fast',
      trainTypeL: 'L Temporary cross-bureau',
      trainTypeA: 'A Temporary bureau',
      trainTypeX: 'X Parcel',
      trainTypeY: 'Y Tourist',
      trainTypeNormal: 'Regular train',
      typeG: 'High-speed EMU',
      typeD: 'EMU',
      typeS: 'Suburban',
      typeZ: 'Direct express',
      typeT: 'Express',
      typeK: 'Fast',
      typeC: 'Intercity',
      typeN: 'Regional fast',
      typeL: 'Temporary cross-bureau',
      typeA: 'Temporary bureau',
      typeX: 'Parcel',
      typeY: 'Tourist',
    },
    sort: {
      earliestDepart: 'Depart',
      shortestDuration: 'Duration',
      lowestPrice: 'Price',
    },
    passenger: {
      typeTitle: 'Passenger type',
      typeSection: 'Passenger type',
      adult: 'Adult',
      adultTicket: 'Adult',
      child: 'Child',
      childTicket: 'Child',
      student: 'Student',
      disabledMilitary: 'Disabled military',
      name: 'Name',
      namePlaceholder: 'Full name',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      cardType: 'ID type',
      idType: 'ID type',
      cardNumber: 'ID number',
      idNumber: 'ID number',
      cardNumberPlaceholder: 'Enter ID number',
      idNumberPlaceholder: 'Enter ID number',
      saveEdit: 'Save changes',
      confirmAdd: 'Confirm add',
      selectIdType: 'Select ID type',
      idCardNi: 'ID card',
      mobile: 'Mobile',
      mobilePlaceholder: 'Enter mobile number',
      tipsTitle: 'Per railway rules:',
      tip1: '1. Only Resident ID cards are supported; ensure your ID is valid',
      tip2: '2. Provide a valid adult contact number; for minors without a phone, use a guardian\'s number',
      tip3: '3. Real-name booking — enter the passenger\'s own details accurately',
      childAloneWarning: 'Children cannot travel alone; at least one adult is required',
      childChangeAloneWarning: 'Child tickets cannot be changed alone; change with an adult ticket',
      remainingChildWarning: 'Remaining passengers include a child without an adult — please reselect',
      idTypeNI: 'ID card',
      idTypePP: 'Passport',
      idTypeHR: 'Household register',
      idTypeJR: 'Military ID',
      idTypeHMP: 'HK/Macau pass',
      idTypeTB: 'Taiwan compatriot pass',
      idTypeHX: 'Home return permit',
      idTypeBC: 'Birth certificate',
      idTypeHK: 'HK/Macau resident permit',
      idTypeHM: 'HK/Macau pass',
      idTypeTW: 'Taiwan pass',
      idTypeFP: 'Permanent residence (foreign)',
    },
    service: {
      expertTitle: 'Rail travel experts',
      changeRefund: 'Flexible changes',
      quickTicket: 'Fast ticketing',
      support247: '24/7 support',
    },
    home: {
      title: 'China rail tickets',
      cardTitle: 'China rail tickets',
      defaultFrom: 'Beijing',
      defaultTo: 'Shanghai',
      tabHome: 'Home',
      tabOrders: 'Orders',
      highSpeedOnly: 'High-speed rail',
      searchBtn: 'Search trains',
      serviceTitle: 'Rail travel experts',
      serviceRefund: 'Flexible changes',
      serviceFast: 'Fast ticketing',
      serviceSupport: '24/7 support',
      shareTitle: 'Train search',
    },
    tab: {
      home: 'Home',
      orders: 'Orders',
    },
    select: {
      loading: 'Loading cities…',
      loadingCities: 'Loading cities…',
      placeholder: 'City or station',
      searchPlaceholder: 'City or station',
      history: 'Recent',
      clear: 'Clear',
      hot: 'Popular',
      hotRecommend: 'Popular',
      chooseCity: 'Select city',
      selectCity: 'Select city',
      searching: 'Searching…',
      empty: 'No stations found',
      noResults: 'No stations found',
      emptyTip: 'Try another keyword',
      tryOtherKeyword: 'Try another keyword',
      city: 'City',
      station: 'Station',
      badgeCity: 'City',
      badgeStation: 'Station',
      historyCleared: 'History cleared',
    },
    refund: {
      selectPassengerSingle: 'Select passenger to refund (one only)',
      noticeTitle: 'Refund policy',
      noticeFeeTitle: 'Railway refund fees:',
      noticeFee1: '1) 8+ days before departure: free',
      noticeFee2: '2) 48+ hours before: 5% of fare',
      noticeFee3: '3) 24–48 hours before: 10% of fare',
      noticeFee4: '4) Less than 24 hours before: 20% of fare',
      noticeFee5: '5) Online refund stops 2 hours after departure',
      noticeDescTitle: 'Notes:',
      noticeDesc1: '1) Fees are charged by China Railway',
      noticeDesc2: '2) Minimum fee is ¥2',
      noticeDesc3: '3) Tickets changed to 8+ days out within 7 days of departure: 5% fee on refund',
      noticeDesc4: '4) Booking fees are non-refundable after purchase',
      noticeDesc5: '5) Platform adds ¥17 per person (non-12306 bookings)',
      noticeDesc6: '6) Refunds arrive in about 7 business days',
      feeDetailTitle: 'Refund fee breakdown',
      refundTicketAmount: 'Ticket amount refunded',
      feeDetailSection: 'Refund fee details:',
      fee12306: '• 12306 refund fee',
      feePlatform: '• Platform service fee',
      feeSubtotal: 'Refund fees subtotal',
      estimatedRefund: 'Estimated refund',
      selectedPassenger: 'Passenger selected',
      estimatedRefundShort: 'Est. refund',
      confirmRefund: 'Confirm refund',
      popupFeeDetailTitle: 'Refund fee breakdown',
      popupRefundAmount: '1. Ticket amount refunded:',
      popupDeductFees: '2. Deductions:',
      popupServiceFeeDesc: 'Booking service fee',
      popupServiceFeeNoRefund: 'is non-refundable.',
      popupRefundCostDesc: '12306 refund fee',
      popupPlatformFeeDesc: 'Platform service fee',
      popupSummary: 'Estimated amount you will receive:',
      continueQuestion: 'Continue?',
      stillProceed: 'Proceed anyway',
    },
    refundProgress: {
      refundAmount: 'Refund amount',
      platformServiceFee: 'Platform fee',
      fee12306: '12306 fee',
      tip1: '• Refund returns to your original payment method',
      tip2: '• Arrival time depends on your bank (usually 1–3 business days)',
      tip3: '• Questions? Call support: 4007659936',
      emptyTitle: 'No refund progress yet',
      emptyDesc: 'Check again later or contact support',
      refresh: 'Refresh',
      backToOrder: 'Back to order',
      statusCompleted: 'Refund successful',
      statusPending: 'Refund processing',
      statusFailed: 'Refund failed',
      defaultDesc: 'Processing refund request',
    },
    change: {
      originalOrder: 'Original booking',
      selectPassenger: 'Select passengers to change',
      selectedCount: '{count} selected',
      childTip: 'Child tickets must be changed with an adult',
      remainingAdultTip: 'Remaining passengers include a child without an adult — reselect passengers',
      noPassengerTitle: 'No changeable passengers',
      noPassengerDesc: 'Ticket status does not allow changes for this order',
      changeOptions: 'Change options',
      fromStation: 'From',
      toStation: 'To',
      departDate: 'Departure date',
      dateRestrictionTip: 'Per change rules, you can only change to trains today',
      stationRestrictionTip: 'Destination cannot be changed within 48 hours of departure',
      rulesTitle: 'Change policy',
      rule1: 'Each ticket can be changed once; changed tickets can be refunded but not changed again;',
      rule2: 'Paper tickets or receipts must be changed at the station counter;',
      rule3: '48+ hours before departure: change to any train within presale period;',
      rule4: 'Within 48 hours: change to another train before departure;',
      rule5: 'After departure: change to another train with seats before 24:00 same day.',
      rule6: 'Tickets changed after departure cannot be refunded',
      searchTrains: 'Search changeable trains',
      selectDepartDate: 'Select departure date',
    },
    changeOrderDetail: {
      countdownRemaining: '{time} left',
      countdownExpired: 'Expired',
      countdownFormat: '{minutes}m {seconds}s',
      changeOrderNo: 'Change order no.: {no}',
      originalOrderNo: 'Original order no.: {no}',
      originalTrip: 'Original trip',
      changedTicket: 'Changed ticket',
      passengerInfo: 'Passengers ({count})',
      expandAllPassengers: 'Show all passengers ({count})',
      stopStations: 'Stops >',
      feeDetail: 'Fee breakdown',
      newTicketTotal: 'New ticket total',
      changeRefundAmount: 'Refund after change',
      oldTicketTotal: 'Original ticket total',
      oldTicketRefund: 'Original ticket refund',
      serviceFee: 'Service fee',
      paidAmount: 'Amount paid',
      actualPaid: 'Amount due',
      changeRules: 'Change policy',
      changeRulesLink: 'Refund & change policy',
      viewChangeRules: 'Tap to view change policy',
      changeRulesItem: 'Change rules',
      changeFeeItem: 'Change fees',
      cancelChange: 'Cancel change',
      payNow: 'Pay now',
      stopStationsTitle: 'Stop list',
      stopNotice: 'Subject to actual operation; follow station announcements',
      loadingStops: 'Loading stops…',
      stopHeaderName: 'Station',
      stopHeaderArrive: 'Arrive',
      stopHeaderDepart: 'Depart',
      stopHeaderStay: 'Stop',
      rulesPopupTitle: 'Change & refund policy',
      rulesRefundFeeTitle: 'Refund fee schedule',
      rulesChangeTitle: 'Change rules',
      rulesSpecialTitle: 'Special cases',
      rulesTipTitle: 'Tips',
      guideRulesTitle: 'Change rules',
      guideFeeTitle: 'Change fees',
      guideHelpTitle: 'Help',
      guideSpecialTitle: 'Important notes',
      guideBasicRules: 'Basic change rules',
      guideTimeRules: 'Time limits',
      guideFeeStandard: 'Change fee schedule',
      guideOtherRules: 'Other rules',
      guideFormulaTitle: 'Fee calculation',
      guideFormulaText: 'Compare new fare + service fee with original fare',
      guideFormulaNote: 'Payment and refund depend on the difference',
      guideNeedPay: 'New fare + fee > original fare',
      guideNeedPayResult: 'Payment required',
      guideNoPay: 'New fare + fee < original fare',
      guideNoPayResult: 'No payment',
      guideFeeExplain: 'Fee notes',
      guideHelpNeed: 'Need help?',
      guideHelpText: 'Our support team is here to help',
      guideHotline: 'Hotline: 4007659936',
      guideServiceHours: 'Hours: 24/7',
      statusPaySoon: 'Please pay soon',
      statusTicketing: 'Issuing ticket, please wait',
      statusTicketSuccess: 'Ticket issued — bring valid ID',
      statusTicketFailed: 'Issue failed — contact support',
      statusCancelled: 'Order cancelled',
      statusPartialRefunding: 'Partial refund in progress',
      statusPartialRefunded: 'Partial refund done — balance will return',
      statusRefunding: 'Refund in progress',
      statusRefunded: 'Refund complete — funds will return',
      statusChanged: 'Change successful — bring valid ID',
      statusChanging: 'Change in progress',
      statusChangeCancelled: 'Change order cancelled',
      statusChangeFailed: 'Change failed — you may reapply',
      statusPartialRefundFailed: 'Partial refund failed — contact support',
      statusRefundFailed: 'Refund failed — contact support',
      statusDefault: 'Order details',
      progressTicketing: 'Issuing ticket',
      progressRefunding: 'Refunding',
      progressChanging: 'Changing',
      progressDone: 'Completed',
      ticketStatusPending: 'Pending payment',
      ticketStatusProcessing: 'Issuing',
      ticketStatusIssued: 'Issued',
      ticketStatusFailed: 'Issue failed',
      ticketStatusCancelled: 'Cancelled',
      ticketStatusRefunding: 'Refunding',
      ticketStatusRefunded: 'Refunded',
      ticketStatusChanging: 'Changing',
      ticketStatusChanged: 'Changed',
      ticketStatusChangeFailed: 'Change failed',
      ticketStatusRefundFailed: 'Refund failed',
      confirmCancelTitle: 'Notice',
      confirmCancelMsg: 'Cancel this change order?',
      confirmCallTitle: 'Contact support',
      confirmCallMsg: 'Call support: 4007659936?',
      guideSpecialFee: 'Platform adds ¥17 change/refund fee per person (non-12306 bookings)',
      guideSpecialSpring: 'Spring Festival travel dates: 20% refund fee applies on subsequent refunds',
      guideBasicRule1: 'Change covers date, time, train, seat class, or destination',
      guideBasicRule2: 'One change per ticket when capacity is available',
      guideBasicRule3: 'Destination changes require 48+ hours before departure',
      guideTime48PlusTitle: '48+ hours before departure',
      guideTime48PlusDesc: 'Free change to any train within presale period',
      guideTime48MinusTitle: 'Less than 48 hours before',
      guideTime48MinusDesc: 'Free change to earlier dates; later dates incur change fee',
      guideTimeAfterTitle: 'Before 24:00 same day after departure',
      guideTimeAfterDesc: 'Free change to same-day trains; next-day+ incurs change fee',
      guideFeeRule1: '24–48 hours before, changing to a later date: 5% of lower fare',
      guideFeeRule2: 'Less than 24 hours before, changing to a later date: 15% of lower fare',
      guideFeeRule3: 'After departure, changing to next-day+: 40% of lower fare',
      guideOtherRule1: 'Paper receipt or cash tickets: change at station counter only; receipt must be returned',
      guideOtherRule2: 'Tickets changed after departure cannot be refunded',
      guideOtherRule3: 'Change fees round to nearest ¥0.50 (minimum ¥2)',
      guideNoticeContent: 'Per China Railway 12306 latest rules. See official regulations for details.',
      guidePayLabel: 'Pay: new fare + service fee',
      guideRefundLabel: 'Refund: original fare',
      guidePayZero: 'Pay: ¥0',
      guideRefundDiff: 'Refund: original fare − (new fare + service fee)',
      guideFeeNoticeContent: 'Fees depend on fare difference plus service fee. Lower total = refund difference; higher total = pay full amount and get original fare back',
      badge48Plus: '48h+',
      badge48Minus: '<48h',
      badgeAfterDepart: 'After dep.',
      percentHighlight: '{percent}%',
      rulesPopupChangeBody: 'Note: Platform adds ¥17 change/refund fee per person (non-12306 bookings).\n\nSpring Festival travel dates: 20% refund fee on subsequent refunds.\n\n1. Basic change rules\nOne change per ticket when capacity is available. See China Railway regulations for time limits, fees, receipts, fare differences, and cross-border tickets.',
      rulesPopupSpecialBody: '1) Special cases per regulations\n2) Free refund if train cancelled or delayed 2+ hours\n3) Refunds in ~7 business days\n4) Subject to latest railway announcements',
      rulesPopupTipPrefix: 'Based on China Railway 12306 rules. Visit ',
    },
    toast: {
      missingParams: 'Missing required parameters',
      missingStationCode: 'Missing station codes — please reload train details',
      stopStationFailed: 'Could not load stops',
      queryStopStationFailed: 'Failed to load stops',
      trainSoldOut: 'This train is sold out — choose another',
      tooCloseToDepart: 'Too close to departure — booking unavailable',
      verifyFailed: 'Verification failed — try again',
      searchParamsIncomplete: 'Incomplete search parameters',
      networkError: 'Network error — try again',
      searchFailed: 'Search failed — try again',
      seatNoTicket: 'No tickets for this seat class',
      selectSeatFirst: 'Please select a seat class first',
      copyFailed: 'Copy failed',
      pleaseLogin: 'Please sign in first',
      loginStatusFailed: 'Could not verify login status',
      loginStatusRetry: 'Login check failed — try again',
      trainDetailFailed: 'Could not load train details',
      trainDetailRetry: 'Could not load train details — try again',
      standingOn: 'Standing tickets accepted — may improve success rate',
      standingOff: 'Standing tickets no longer accepted',
      deleteSuccess: 'Deleted',
      deleteFailed: 'Delete failed',
      passengerListFailed: 'Could not load passenger list',
      changeFeeFailed: 'Could not load change fee',
      seatDataFailed: 'Seat data failed to load',
      seatMapFailed: 'Seat map failed to load',
      maxSeats: 'You can select up to {count} seats',
      maxBerths: 'You can select up to {count} berths',
      agreementConfirmed: 'All terms accepted',
      couponFailed: 'Could not load coupons',
      couponSelected: 'Coupon applied — save ￥{amount}',
      selectCouponFailed: 'Could not apply coupon',
      couponCancelled: 'Coupon removed',
      selectPassenger: 'Please select passengers',
      selectSeat: 'Please select seats',
      checkAgreement: 'Please accept the terms before submitting',
      orderSubmitCancelled: 'Order submission cancelled',
      orderSubmitFailed: 'Order submission failed — try again',
      orderSubmitSuccess: 'Order submitted',
      selectPassengerFirst: 'Please select passengers first',
      changeSubmitPay: 'Change submitted — proceed to payment',
      changeSuccess: 'Change successful',
      changeSubmitFailed: 'Change submission failed',
      cityListFailed: 'Could not load cities — try again',
      loadCitiesFailed: 'Could not load cities — try again',
      historyCleared: 'History cleared',
      searchStationFailed: 'Search failed — try again',
      enterName: 'Please enter passenger name',
      enterIdNumber: 'Please enter ID number',
      enterMobile: 'Please enter mobile number',
      addSuccess: 'Passenger added',
      saveFailedRetry: 'Save failed — try again',
      loadPassengerSuccess: 'Passenger loaded',
      loadPassengerListFailed: 'Could not load passenger list',
      loadPassengerDetailFailed: 'Could not load passenger details',
      invalidIdCard: 'Please enter a valid ID number',
      autoChildTicket: 'Set to child ticket based on ID',
      nameRequired: 'Please enter passenger name',
      cardRequired: 'Please enter ID number',
      mobileRequired: 'Please enter mobile number',
      invalidMobile: 'Please enter a valid mobile number',
      saveSuccess: 'Passenger added',
      editSuccess: 'Passenger updated',
      saveFailed: 'Save failed',
      saveRetry: 'Save failed — try again',
      passengerLoaded: 'Passenger loaded',
      passengerNotFound: 'Passenger not found',
      passengerListLoadFailed: 'Could not load passenger list',
      passengerDetailFailed: 'Could not load passenger details',
      changeOrderNotFound: 'Change order not found',
      cancelSuccess: 'Cancelled',
      cancelChangeSuccess: 'Change cancelled',
      cancelChangeFailed: 'Could not cancel change',
      cancelChangeRetry: 'Could not cancel change — try again',
      noInvoiceData: 'No invoice data',
      invoiceListFailed: 'Could not load invoices',
      orderDetailFailed: 'Could not load order details',
      changeOrderDetailFailed: 'Could not load change order details',
      refundProgressFailed: 'Could not load refund status',
      missingOrderNo: 'Missing order number',
      refreshed: 'Refreshed',
      selectRefundPassenger: 'Please select a passenger to refund',
      refundFeeQueryFailed: 'Could not calculate refund fee',
      ticketNonRefundable: 'This ticket is non-refundable',
      refundFeeQuerying: 'Calculating fee — please wait',
      refundSubmitSuccess: 'Refund request submitted',
      refundSubmitFailed: 'Refund request failed',
      noRefundablePassenger: 'No refundable passengers on this order',
      changeWithin48h: 'Destination cannot be changed within 48 hours of departure',
      selectAtLeastOne: 'Please select at least one passenger',
      childChangeNeedAdult: 'Child tickets need at least one adult for change',
      remainingChildNoAdult: 'Remaining passengers include a child without an adult — reselect',
      orderNoEmpty: 'Order number is required',
      operationFailed: 'Operation failed',
      queryingFee: 'Checking fees…',
      queryFeeFailed: 'Failed to check fees',
      notRefundable: 'This ticket cannot be refunded',
      queryingFeeWait: 'Checking fees, please wait…',
      applyingRefund: 'Submitting refund…',
      refundApplySuccess: 'Refund request submitted',
      refundApplyFailed: 'Refund request failed',
      missingOrderId: 'Missing order number',
      selectOnePassenger: 'Select at least one passenger',
      childNeedAdult: 'Child tickets need at least one adult',
      remainingAdultIssue: 'Remaining passengers include a child without an adult — reselect',
      stationChangeRestricted: 'Destination cannot be changed within 48 hours of departure',
      queryStopFailed: 'Failed to load stops',
      changeDetailFailed: 'Failed to load change order',
    },
    btn: {
      refundHistory: 'Refund history',
      applyRefund: 'Request refund',
      confirmRefund: 'Confirm refund',
      submitRefund: 'Submit refund',
      viewRefundProgress: 'View refund status',
      applyChange: 'Request change',
      confirmChange: 'Confirm change',
      cancelChange: 'Cancel change',
      addPassenger: 'Add passenger',
      editPassenger: 'Edit passenger',
      savePassenger: 'Save passenger',
      deletePassenger: 'Delete passenger',
      selectTrain: 'Select train',
      viewTimetable: 'View timetable',
      goPay: 'Pay now',
      reorder: 'Book again',
      buyReturn: 'Book return',
      contactService: 'Contact support',
      invoice: 'Invoice / receipt',
      invoiceDetail: 'Invoice details',
      amountDetail: 'Order breakdown',
      continueOrder: 'Continue booking',
      continueChange: 'Continue change',
      selectHotel: 'Choose hotel',
      refresh: 'Refresh',
    },
    detail: {
      loading: 'Loading train details…',
      selectSeatType: 'Select seat class',
      convenientBuy: 'Quick booking',
      noLogin12306: 'No 12306 login required',
      perPerson: '/person',
      proService: 'Expert support',
      service247Short: '24/7 service',
      bookingNoticeTitle: 'Before you book:',
      bookingNoticeBody: '• Verify passenger details and valid ID\n• Arrive at the station early (30+ minutes recommended)\n• Check station announcements for delays or cancellations',
      refundRulesTitle: 'Change & refund policy:',
      refundRulesSummary: 'Fees follow China Railway rules. Refunds usually arrive in 1–3 business days.',
      viewRulesLink: 'View full policy',
      checkingLogin: 'Checking login…',
      stopLink: 'Stops >',
      seatSelected: 'Selected {seat}',
    },
    orderDetail: {
      statusInit: 'Initializing order',
      statusTicketFailedReorder: 'Issue failed — you may book again',
      statusPartialRefunding: 'Partial refund in progress',
      statusPartialRefunded: 'Partial refund completed',
      statusRefunding: 'Processing refund',
      statusRefunded: 'Refund completed',
      statusPartialRefundFailed: 'Partial refund failed',
      confirmCancelMsg: 'Cancel this order?',
      passengerUnit: '{count} passenger(s)',
      changeStatusInit: 'Initial',
      changeStatusPayPending: 'Pending payment',
      changeStatusTicketing: 'Issuing',
      changeStatusTicketSuccess: 'Issued',
      changeStatusTicketFailed: 'Issue failed',
      changeStatusCancelled: 'Cancelled',
      changeStatusPartialRefunding: 'Partial refunding',
      changeStatusPartialRefunded: 'Partial refunded',
      changeStatusRefunding: 'Refunding',
      changeStatusRefunded: 'Refunded',
      changeStatusChanged: 'Changed',
      changeStatusChanging: 'Changing',
      changeStatusChangeCancelled: 'Change cancelled',
      changeStatusChangeFailed: 'Change failed',
      changeStatusPartialRefundFailed: 'Partial refund failed',
      changeStatusRefundFailed: 'Refund failed',
      childTicketRulesTitle: 'Child ticket pricing',
      childAgeUnder6: 'Under 6:',
      childAgeUnder6Desc: 'Free, no seat',
      childAge6to14: 'Age 6–14:',
      childAge6to14Desc: 'Half price, with seat',
      childAge14Plus: 'Age 14+:',
      childAge14PlusDesc: 'Full price, with seat',
      childTicketRefundNotice: 'Child tickets are charged at adult fare; difference refunded after issue',
      seatPreferenceNotice: 'Seat preferences shown as selected at booking; actual seats may differ',
      invoiceListTitle: 'Train invoices',
      invoiceAmount: 'Amount: ￥{amount}',
      ticketCountFormat: '{count} × {seatType}',
      selectSeatsLabel: 'Seats: {seats}',
      sleeperSeatSelect: 'Sleeper berths',
      seatPreference: 'Seat preference',
      businessSeatSelect: 'Business class seats',
      firstClassSeatSelect: 'First class seats',
      secondClassSeatSelect: 'Second class seats',
      highSpeedSeatSelect: 'High-speed seat selection',
    },
    orderFill: {
      changePassenger: 'Passengers to change',
      passengerInfo: 'Passengers',
      selectedSummary: '{count} selected (adult {adult}{childPart})',
      childPart: ', child {count}',
      selectedSeats: 'Seats: {seats}',
      seatLegend: 'Seat legend',
      seatAvailable: 'Available',
      seatSelectedLabel: 'Selected',
      windowLabel: 'Window',
      aisleLabel: 'Aisle',
      upperBerth: 'Upper',
      middleBerth: 'Middle',
      lowerBerth: 'Lower',
      upperBerthDesc: 'Lower price, less space',
      middleBerthDesc: 'Mid price, easier access',
      lowerBerthDesc: 'Higher price, most convenient',
      berthSelectedSummary: '{selected} berths selected / {total} needed',
      windowSeat: 'Window',
      aisleSeat: 'Aisle',
      windowSeatDesc: 'Scenic, quieter',
      aisleSeatDesc: 'Easy to move',
      preferenceSelectedSummary: '{selected} preferences / {total} needed',
      selectedSeatsHeader: 'Seats ({selected}/{total})',
      selectedBerthHeader: 'Berths ({selected}/{total})',
      selectedPreferenceHeader: 'Preferences ({selected}/{total})',
      berthMultiply: '{type} × {count}',
      bookingOptions: 'Booking options',
      changeOptions: 'Change options',
      acceptNoSeatDesc: 'If sold out, buy standing ticket?',
      acceptNoSeatDescChange: 'If sold out, accept standing ticket?',
      orderDetail: 'Order breakdown',
      changeFeeDetail: 'Change fee breakdown',
      ticketInfo: 'Ticket info',
      changeTicketLabel: 'Changed ticket',
      originalTicketAdult: 'Original ticket (adult)',
      estimatedRefund: 'Estimated refund',
      needPayAmount: 'Amount due',
      ticketSubtotal: 'Ticket subtotal',
      serviceFeeRow: 'Service fee',
      couponDiscountRow: 'Coupon',
      totalRow: 'Total',
      submitChange: 'Submit change',
      submitOrder: 'Submit order',
      seatNumberSuffix: '',
      deletePassengerMsg: 'Delete passenger "{name}"?',
      smsVerifyTitle: 'SMS verification required',
      smsVerifyMsg: 'Complete SMS verification to continue',
      nonRefundableTitle: 'Non-refundable ticket',
      nonRefundableMsg: 'This ticket is non-refundable. Continue with {action}?',
      gotIt: 'Got it',
      totalPayAmount: 'Total due',
      estimatedRefundNote: '(Refund after change success; allow up to 7 business days)',
      reminderChild: 'Child tickets are charged at adult fare; the difference is refunded after ticketing.',
      reminderStandby: 'Standby orders require prepayment at the highest fare in the order (lower berth for sleepers). If prepayment exceeds the actual fare after fulfillment, the difference is refunded automatically.',
      couponLoading: 'Loading coupons...',
      noCouponUse: 'Do not use coupon',
      couponValidUntil: 'Valid until: {date}',
      couponDefaultLabel: 'Coupon',
      couponPercentOff: '{price}% off',
      couponDiscountUnit: 'off',
      agreementReadConfirm: 'I have read and agree',
      serviceConfirmTitle: 'Important notice',
      serviceConfirmBody: 'This order includes a service fee of {amount} CNY. It helps secure your ticket. Once issued, the service fee is non-refundable if you refund or change the ticket.',
      thinkAgain: 'Think again',
      agreeAndPay: 'Agree and pay',
      agreement: {
        publishDates: 'Published: Dec 22, 2023\nEffective: Dec 29, 2023',
        personalInfoBody: 'Thank you for using our train ticket booking service. The service provider shown on the order confirmation page will deliver the service. We may transfer your selected product and personal information to that provider to verify identity, confirm your order, and fulfill the service.\n\nBefore sharing data, we comply with applicable personal information protection laws and our privacy policy. Providers must process your data only for service delivery and must not transfer, share, sell, or use it for other purposes.\n\nPlease verify your selections and personal information. By proceeding to book or pay, you authorize us to share the necessary personal information with the service provider. If the order includes a minor, you confirm you are the guardian (or have consent) and authorize processing of the minor\'s information for this service.',
        purchaseNoticeBody: '1. E-ticket notice\n1) E-tickets are paperless; use your ID to enter the station.\n2) Supported IDs for self-service gates include PRC ID, foreign permanent residence ID, HK/Macao/Taiwan residence permits, e-passport, and travel permits.\n\n2. Waitlist / grab notice\n1) Payment starts ticket grabbing; release often happens 1–3 days before departure.\n2) Alternates may be charged at the highest selected fare; difference is refunded after ticketing.\n\n3. Ticket collection\n1) Most trains support e-tickets with ID.\n2) If e-tickets are unavailable, collect paper tickets at the station with your ID.\n\n4. Child tickets\n1) Under 6 free (no seat); 6–14 half price with seat; 14+ full price.\n2) Child fares are charged at adult price first; difference refunded after ticketing.\n\n5. Refund & change\nRailway refund fees apply by time before departure (free 8+ days; 5%/10%/20% closer to departure). Platform fees and processing rules also apply. Refunds typically arrive within 7 business days.',
        serviceBody: 'Train services on this platform are operated by the platform operator and third-party providers. By using train booking, refund, change, and waitlist services, you authorize us to register or verify your 12306 account where required.\n\nWe may transfer your booking selections and personal information to service providers under applicable privacy laws.\n\nDisclaimer: Timetable and availability come from railway operators; we do not guarantee 100% ticketing success. We are not liable for railway delays, cancellations, or force majeure. You are responsible for complying with railway rules.\n\nDisputes are governed by PRC law and the courts of Tianhe District, Guangzhou.',
      },
    },
    rules: {
      popupTitle: 'Change & refund policy',
      refundFeeTitle: 'Refund fee schedule',
      changeTitle: 'Change rules',
      specialTitle: 'Special cases',
      tipTitle: 'Tips',
    },
    popup: {
      amountDetail: 'Order breakdown',
      applyRefund: 'Request refund',
      refundHistory: 'Refund history',
      invoiceDetail: 'Invoice details',
      filterTitle: 'Filters',
      cardTypeTitle: 'Select ID type',
      stopStations: 'Stop list',
      refundChangeRules: 'Change & refund policy',
      selectCoupon: 'Select coupon',
      confirmDelete: 'Confirm delete',
      contactService: 'Contact support',
      tip: 'Notice',
      nonRefundable: 'Non-refundable ticket',
      agreementPersonalInfo: 'Personal data authorization',
      agreementPurchaseNotice: 'Booking notice',
      agreementService: 'Train service agreement',
    },
  },
}
